// extracted by mini-css-extract-plugin
export default {"container":"SuccessPaymentPage_container__6bVPW","icon":"SuccessPaymentPage_icon__wVj2W","formButton":"SuccessPaymentPage_formButton__or-TK"};